import React from 'react'
import { useState } from 'react'
import { Modal, Button, Form, InputGroup, Breadcrumb } from 'react-bootstrap'
import Select from 'react-select'
import CustomLabel from './CustomLabel'
import { toast } from 'react-toastify'

function AddTypeModal({ AddTypeModalProps }) {
    const { rowInputChangeHandler, isMultiSelect, type, countries, nationalities, locales, localesChangeHandler, rows, addRowHandler, removeRowHandler, onEnterHandler, btnClicked, addBtnHandler, showModal, closeModalHandler } = AddTypeModalProps
    const [range, setRange] = useState({ lower: null, upper: null, excludeUpperLimit: false })

    const isRangeType = (type.value === 'salarylevels')

    const excludeKeys = (e) => {
        if (e.code === 'KeyE' || ['+', '-', '.'].includes(e.key))
            return e.preventDefault()
        if (!btnClicked && e.key === 'Enter')
            addRangeBtnHandler()
    }

    const onNumberChangeHandler = (e) => {
        setRange(prevRange => ({
            ...prevRange,
            [e.target.name]: (e.target.value.length > 0 ? parseInt(e.target.value) : null)
        }));
    }

    const addRangeBtnHandler = () => {
        if (btnClicked)
            return
        const { lower, upper, excludeUpperLimit } = range
        if (lower === null) return toast.error('Enter a value for the lower limit')
        if (!excludeUpperLimit) {
            if (upper === null) return toast.error('Enter a value for the upper limit')
            if (lower > upper)
                return toast.error('The starting value should be lower than the ending value')
            addBtnHandler(`$${lower} - $${upper}`)
        }
        else
            addBtnHandler(`$${lower} or more`)
        clearAndCloseModal()
    }

    const clearAndCloseModal = () => {
        setRange({ lower: null, upper: null, excludeUpperLimit: false })
        closeModalHandler()
    }

    return (
        <Modal size='lg' show={showModal} onHide={clearAndCloseModal} centered backdrop='static'
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Add Type for</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group controlId='formEnterValue'>
                    <Breadcrumb>
                        <Breadcrumb.Item key='ROOT' linkAs={CustomLabel}>{type.display}</Breadcrumb.Item>
                    </Breadcrumb>
                    <Form.Label>{isMultiSelect ? 'Select values to be added' : 'Enter a value'}</Form.Label>
                    {!isRangeType
                        ? <>
                            {rows.map((row, index) => (
                                <InputGroup className='mb-3' key={row.id}>
                                    {isMultiSelect
                                        ? <Select
                                            className='no-border-radius-right flex-1'
                                            onChange={option => rowInputChangeHandler(index, option)}
                                            options={type.value === 'location' ? countries : nationalities}
                                            isMulti
                                            placeholder='Choose multiple options'
                                            value={rows[0].value}
                                            isSearchable={false} />
                                        : <Form.Control onKeyDown={onEnterHandler} type='text' onChange={(e) => rowInputChangeHandler(index, e.target.value.trimStart())} value={row.value} placeholder='Enter a value...' />
                                    }
                                    <Select
                                        className={`no-border-radius-left ${!row.locale.isDefault && 'no-border-radius-right'}`}
                                        options={locales}
                                        value={row.locale}
                                        placeholder='Locales'
                                        isSearchable={false}
                                        onChange={option => localesChangeHandler(index, option)}
                                        isDisabled={row.locale.isDefault}
                                    />
                                    {!row.locale.isDefault && <Button variant='danger' onClick={() => removeRowHandler(index)}>Remove</Button>}
                                </InputGroup>
                            ))}
                            {(!isMultiSelect) && (rows.length < locales.length) &&
                                <Button variant='secondary' onClick={addRowHandler}>Add another value</Button>
                            }
                        </>
                        : <>
                            <InputGroup className='mb-3'>
                                <Form.Control onKeyDown={excludeKeys} type='number' name='lower' onChange={onNumberChangeHandler} value={range.lower ?? ''} placeholder='Start From' />
                                <span className="input-group-text">{range.excludeUpperLimit ? 'or more' : 'to'}</span>
                                {!range.excludeUpperLimit &&
                                    <Form.Control onKeyDown={excludeKeys} type='number' name='upper' onChange={onNumberChangeHandler} value={range.upper ?? ''} placeholder='End Before' />
                                }
                            </InputGroup>
                            <Form.Check onChange={e => setRange(prevRange => ({ ...prevRange, excludeUpperLimit: e.target.checked }))} type='checkbox' id='excludeUpper' label='Remove Upper limit' />
                        </>
                    }
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button key='Close' variant='secondary' onClick={clearAndCloseModal}>
                    Close
                </Button>
                <Button disabled={btnClicked} variant='primary' onClick={() => {(isRangeType ? addRangeBtnHandler() : addBtnHandler())}}>Add</Button>
            </Modal.Footer>
        </Modal >
    )
}

export default AddTypeModal